<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12 class="headline mb-4">
        Assign Foreman
      </v-flex>
      <v-flex xs12>
        <v-skeleton-loader v-if="loading" type="table"></v-skeleton-loader>
        <v-card v-else>
          <v-data-table
            :headers="headers"
            :items="updatedJobSites"
            :search="search"
            :items-per-page="25"
            sort-by="createDate"
            sort-desc
          >
            <template v-slot:top>
              <v-toolbar flat color="white" class="pt-1">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="search"
                  append-icon="search"
                  label="Filter by address"
                ></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:item.address="{ item }">
              <p
                class="ma-0 pa-0 body-2 font-weight-bold"
                style="line-height:1.4em"
              >
                {{ item.street }}
                <span class="font-weight-regular"> {{ item.street2 }}</span>
              </p>

              <p class=" ma-0 pa-0" style="line-height:1.4em">
                {{ item.city }}
                {{ item.postalCode }}
              </p>
              <div class="caption grey--text ">
                Created: {{ item.createDate.toDate() | moment("MMM Do YYYY") }}
              </div>
            </template>
            <template v-slot:item.projectManagers="{ item }">
              <div v-if="item.department">
                TYPE: <strong>{{ item.department.join(", ") }}</strong>
              </div>
              <div v-if="item.projectManagers">
                PM:
                <strong>{{
                  item.projectManagers.map((pm) => pm.name).join(", ")
                }}</strong>
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <v-autocomplete
                :items="allForeman"
                return-object
                item-text="name"
                v-model="item.assignedForeman"
                @change="updateForeman(item)"
                chips
                deletable-chips
                multiple
                small-chips
                hide-details
                dense
              >
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content class="py-1">
                      <v-list-item-title>
                        {{ data.item.name }} ({{ data.item.email }})
                      </v-list-item-title>
                      <!-- <v-divider class="mt-1 grey--text lighten-4"></v-divider> -->
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </template>
            <template v-slot:item.surveyName="{ item }">
              <v-select
                :items="allSurveyNames"
                v-model="item.surveyName"
                @change="updateSurveyName(item)"
              ></v-select>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
export default {
  data() {
    return {
      search: "",
      loading: true,
      headers: [
        { text: "Job Id", value: "jobId", width: "90" },
        {
          text: "Address",
          align: "left",
          value: "address",
          width: "280",
        },
        { text: "PM", value: "projectManagers", align: "left", width: 240 },
        {
          text: "Foreman",
          value: "status",
          align: "left",
          width: 300,
          sortable: false,
        },
        {
          text: "Survey",
          value: "surveyName",
          align: "left",
          width: 120,
          sortable: false,
        },
      ],
      allForeman: [],
      snack: false,
      snackColor: "",
      snackText: "",
      allSurveyNames: [],
    };
  },
  async created() {
    // get foreman for assignments
    this.loading = true;
    try {
      const allForemanRes = await fb.db
        .collection("users")
        .where("role", "in", ["Foreman", "Payroll Clock-In"])
        .get();
      let allForeman = [];
      allForemanRes.forEach((u) => {
        if (u.data().access) {
          allForeman.push({
            name: u.data().firstName + " " + u.data().lastName,
            email: u.data().email,
            id: u.id,
          });
        }
      });
      this.allForeman = allForeman;
      const surveyRes = await fb.db.collection("surveys").get();
      surveyRes.forEach((s) => {
        this.allSurveyNames.push(s.id);
      });
      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.log(error);
      alert(error.message);
    }
  },
  computed: {
    ...mapState(["jobSites", "user"]),
    updatedJobSites() {
      return this.jobSites.map((j) => {
        return { ...j, surveyName: j.surveyName || "standard" };
      });
    },
  },
  methods: {
    async updateForeman(job) {
      try {
        await fb.db.doc(`jobSites/${job.id}`).update({
          assignedForeman: job.assignedForeman,
        });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Successfully updated job!";
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating job!" + error.message;
      }
    },
    async updateSurveyName(job) {
      try {
        await fb.db.doc(`jobSites/${job.id}`).update({
          surveyName: job.surveyName || "standard",
        });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Successfully updated job!";
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating job!" + error.message;
      }
    },
  },
};
</script>

<style>
#edit-card input,
#edit-card .theme--light.v-select .v-select__selection--disabled {
  color: black !important;
}
</style>
